<template>
  <div class="privacyPolicy">
    <div class="font50phone privacyPolicy-tlt">隐私政策</div>
    <div class="privacyPolicy-top">
      开发者名称：银川谷医堂互联网医院有限公司<br />
      应用名称：脂玫乐<br />
      更新日期：2021年12月25日 <br />
      生效日期：2021年12月25日 <br />
    </div>
    <div class="privacyPolicy-top">
      请花一些时间熟悉我们的隐私政策，如果您有任何问题，请告诉我们。
    </div>
    <div class="privacyPolicy-top">我们向您承诺</div>
    <div class="privacyPolicy-top">
      本隐私政策规定了脂玫乐及关联方（下文简称"脂玫乐"或"我们"）如何收集、使用、披露、处理和保护您在使用我们的产品和服务时通过脂玫乐APP提供给我们的信息。本软件尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本软件会按照本隐私权政策的规定使用和披露您的个人信息。但本软件将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本软件不会将这些信息对外披露或向第三方提供。本软件会不时更新本隐私权政策。您在同意本软件服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本软件服务使用协议不可分割的一部分。
    </div>
    <div class="privacyPolicy-main">
      <div class="privacyPolicy-li">
        <div class="li-tlt">1.适用范围</div>
        在您使用本软件网络服务，本软件自动接收并记录的您的手机上的信息，包括但不限于您的健康数据、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据。
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">2.我们如何收集和使用您的个人信息</div>
       我们的产品与/或服务包括一些核心功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：
        <div class="li-tlt2">A.使用、改进我们的产品与/或服务所必须的功能</div>
        <div class="li-tlt2">(1)注册登录</div>
        登录方式包括：手机号注册登录、微信账号登录（脂玫乐小程序）。其中，手机号注册登录需要获取用户的手机号以及收到的验证码；微信账号登录需要获取用户的微信个人信息，包括昵称和头像。
        <div class="li-tlt2">(2)健康评测</div>
        为了给用户提供每日所需热量和目标体重建议，我们会收集用户以下数据：性别、身高、生日、体重、体重目标、日常活动量等数据。
        <div class="li-tlt2">(3)记录类功能</div>
        为给用户提供多方位、便捷的健康管理服务,用户可以自主选择在脂玫乐使用以下记录类功能：<br />
        体重记录：用户可以记录当天的体重和上传照片。我们会帮助用户存储这些信息，并为用户生成体重日历和体重趋势线。<br />
        体围记录：用户可以记录胸围、腰围、臀围、手臂围、大腿围、小腿围，以及上传照片。我们会帮助用户存储这些信息，并为用户生成记录日历和曲线图。<br />
        饮食/运动记录：用户可在此记录他们的饮食和运动,包括记录饮食的类别(早餐、午餐、晚餐或加餐),食物名称和份量,以及做的运动名称和时长。我们还会收集用户HealthKit上步数、步行+跑步、骑行运动数据。我们会帮用户存储这些信息，并根据预算热量、食物摄入热量与运动消耗热量,计算出用户今天还可摄入多少热量。
        <div class="li-tlt2">(4)体脂秤设备管理</div>
        为了帮助用户管理更多的身体数据，将会对接体脂秤设备，我们需要收集您的设备信息和网络信息。设备信息包括设备标识符（IMEI、MAC、UDID、SN）、设备类型和设备配置数据。收集此类信息的目的是为了建立蓝牙连接、管理设备配置、完成软件升级、显示数据来源。网络信息包括 IP 地址、网络类型和网络连接状态，这些数据将被用来提升网络连接体验。通过蓝牙连接体脂秤设备，需要访问手机蓝牙权限和位置权限。连接体脂秤设备后，为了提供更准确的数据监测，您输入的性别、年龄、身高、体重会同步到体脂秤。
        <div class="li-tlt2">(5)摄像头权限</div>
        当您使用我们的拍摄功能时，例如拍摄需要在发布动态中上传的图片时，我们会在获得您的自主选择同意后，获取您的摄像头权限。拒绝提供该权限会使您无法使用上述功能，但不影响您正常使用我们其他功能。您可以随时在手机系统设置中关闭该授权。
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">3.信息的使用</div>
        a)在获得您的数据之后，本软件会将其上传至服务器，以生成您的个人数据或进行整合处理，以便您能够更好地享有脂玫乐服务。<br />
        b)如果因个人填写信息不真实而引起的问题，由您自行承担相应的后果。请您不要将您的帐号转让或出借予他人使用。如您发现您的帐号遭他人非法使用，应立即通知本软件。因黑客行为或用户的保管疏忽导致帐号遭他人非法使用，本软件不承担责任。
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">4.信息披露</div>
        a)本软件不会将您的信息披露给未经您授权同意的第三方； <br />
        b)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；<br />
        c)如您出现违反中国有关法律、法规或者相关规则的情况，需要向第三方披露；
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">5.信息存储</div>
        <div class="li-tlt2">（1）信息存储的地点：</div>
        我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内本软件及（或）其关联方的服务器上，以下情形除外： a.法律法规有明确规定； b.获得您的明确授权； 针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。
        <div class="li-tlt2">（2）信息存储期限：</div>
         我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。 <br />
         我们判断个人信息的存储期限主要依据以下标准： <br />
         A.完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉； <br />
         B.保证我们为您提供服务的安全和质量； <br />
         C.您是否同意更长的留存期间； <br />
         D.是否存在关于保留期限的其他特别约定或法律法规规定，例如病历的相关存储期限要求等。 <br />
         在超出保留期间后，我们会根据适用法律的要求删除或匿名化处理您的个人信息。 <br />
        <div class="li-tlt2">（3）信息删除和匿名化处理</div>
        如本平台服务决定停止运营时，我们将在相关服务停止运营后停止继续收集您的个人信息。我们将以公告形式将停止运营通知向您送达。对已持有的您的个人信息将进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">6.账号注销</div>
        如您需要注销，也可联系我方平台客服，客服在核实用户身份后，会释放用户的手机号，达到注销的效果。在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。您在注销账号前如果有在我方平台上传的视频，如果不希望相关视频在我方平台继续传播，请您自行删除。如您未选择删除的，将视为您同意该等视频继续授权我方平台进行信息网络传播。如您选择不删除相关您上传的视频，在您注销账号后，该等视频在我方平台上展示时上传人信息将做匿名或脱敏处理。<br />
        注销操作是不可恢复的操作，您申请账号注销后，您将无法再登录相应账号使用相关服务，除按照相关法律规定应该保留的相关信息、权益或其他数据外，在您注销账号项下存储、使用等的全部信息、数据等将会在15天内被永久删除，请您谨慎进行账号注销操作。
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">7.本隐私协议如何更新</div>
        我们可能适时会对本隐私协议进行调整或变更，本隐私协议的任何更新将以在线公告、系统通知等方式进行变更公告，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经公布，立即或在公告明确的特定时间自动生效。如您在隐私协议调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接收修改后的隐私协议并受其约束。如您不同意调整或变更后的隐私协议，请您停止使用我们提供的服务或访问我们的相关网站。
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">8.第三方插件目的、方式、范围</div>
        为了给您提供更多的服务和功能，我方可能会通过SDK接口等方式获取您的部分信息（包括：您的设备平台、设备厂商、设备品牌、设备识别码（如IMEI、MA C、IDFA等）等设备信息、麦克风权限、应用列表信息、网络信息（如IP地址、WIFI信息等）以及位置相关信息等）除本客户端提供的服务和能力外，本客户端还集成了第三方SDK，在提供具体服务前通过弹窗方式另行获取您的授权，我们会在授权同意后收集和使用。这些SDK包括：<br />
        （1）极光推送SDK：为了及时向您提供社区动态提醒、订阅消息等服务通知，我们使用了极光推送SDK，如您使用小米、魅族、华为、OPPO、VIVO、苹果手机，我们接入的上述手机厂商PUSH SDK，这些SDK需要获取您的手机终端唯一标识信息、手机当前状态、当前网络状态、应用列表信息、存储权限、唤醒屏幕、通知栏权限、更改网络状态、读取WiFi状态并可能会收集您的手机型号、系统类型、系统版本、设备屏幕尺寸参数用于实现App推送服务；<br />
        （2）友盟统计SDK：为了更好的为您服务，可能需要访问您的设备信息、App类别、App名称、App版本、应用列表信息、读取手机状态和身份、网络权限来进行数据统计，提升业务办理质量；<br />
        （3）geetest一键登录SDK：您使用本客户端的短信验证码登录、一键登录、自动登录功能时，为了保证登录服务正常运行，验证使用设备及登录身份的合法性和安全性以及身份的合法性，我们需要访问您的终端MAC地址、终端唯一识别码、SIM卡信息、IMSI信息、IMEI信息、终端版本型号、网络IP、本机号码、个人姓名、电话号码、住址、邮箱、入网时间、网络类型、应用列表信息和手机品牌信息。<br />
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">9. 我们如何处理儿童的信息</div>
        我们非常重视对儿童信息的保护。<br />
        9.1 如果没有监护人的同意，儿童不得创建自己的用户账户。如您为儿童，我们要求您请您的监护人仔细阅读本隐私权政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。<br />
        9.2 对于经监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、监护人明确同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。
      </div>
      <div class="privacyPolicy-li">
        <div class="li-tlt">10.联系我们</div>
        如果您对本隐私政策有任何疑问、意见或建议，可以通过以下方式与我们联系<br />
        公司名称：银川谷医堂互联网医院有限公司<br />
        注册地址：宁夏银川市西夏区银川中关村创新中心B座2层B229<br />
        常用办公地址：湖南省长沙高新开发区汇智中路179号金荣同心工业园C3栋<br />
        在线客服：400-8855-091<br />
        我们设立了个人信息保护专职部门，您可以通过以下方式联系<br />
        电话联系方式：400-8855-091<br />
        一般情况下，我们将在三十天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：<br />
         "国家移动互联网应用安全管理中心：http://www.cnaac.org.cn/report.html"
      </div>
      <div class="privacyPolicy-fot">
        感谢您花时间了解我们的隐私政策！
      </div>
      <div class="basetitle">附件一：注销协议</div>
      <div class="part_content">
        <p class="part_detail weight marbottom18">
          注销脂玫乐帐号是不可恢复的操作，你应自行备份脂玫乐帐号相关的信息和数据。操作之前，请确认与脂玫乐帐号相关的所有服务均已进行妥善处理。
        </p>
        <p class="part_detail weight marbottom18">
          请谨记：注销脂玫乐帐号，你将无法再使用本脂玫乐帐号或找回你添加或绑定的任何内容或信息(即使你使用相同的手机号码再次注册并使用脂玫乐)，包括但不限于：
        </p>
        <p class="part_detail weight marbottom18">
          (1)你将无法登录、使用本脂玫乐帐号。
        </p>
        <p class="part_detail weight marbottom18">
          (2)你脂玫乐帐号的个人资料和历史信息(包含昵称、头像、二维码名片、消息记录、体重以及体围、蜕变日记、动态等)都将无法找回。
        </p>
        <p class="part_detail weight marbottom18">
          (3)注销脂玫乐帐号前，你的订单状态必须全部为已收货状态。你的脂玫乐获得的优惠券、积分以及钱包都将无法使用。无法使用连接家人的功能。
        </p>
        <p class="part_detail weight marbottom18">
          (4)你通过脂玫乐帐号使用、授权登录或绑定脂玫乐帐号后使用的腾讯公司或第三方的其他服务(包括微信公众号、小程序等)的所有记录将无法找回。你将无法再获得体重以及喝水提醒服务等功能。
        </p>
        <p class="part_detail weight marbottom18">
          (5)在脂玫乐帐号注销期间，如果你的脂玫乐帐号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，脂玫乐有权自行终止你脂玫乐帐号的注销而无需另行得到你的同意。
        </p>
        <p class="weight">
          请注意，注销你的脂玫乐帐号并不代表本脂玫乐帐号注销前的帐号行为和相关责任得到豁免或减轻。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/others/interface';
import {$get, $post, } from '@/others/ajax';

export default {
  name: 'privacyPolicy',
  title () {
    return {
      title: '隐私政策',
      keywords: '隐私政策',
      description: '隐私政策',
    };
  },
  data () {
    return {
      privacy: '',
    };
  },
  methods: {
    getDetail () {
      console.log(123);
      $get(config.zmlgw + '/web/agreements')
        .then((res) => {
          if (res.code == 200) {
            this.privacy = res.data.agreement;
          }
        });
      // let res = ;// 文章详情接口
    },
  },
  mounted () {
    this.getDetail();
    document.getElementById('cnzz_stat_icon_1279115503').style.display = 'none';
  },
};
</script>

<style lang="less" scoped>
@import url("../../../static/css/fontSize.less");

.privacyPolicy-tlt {
  margin-bottom: 30 * @width1;
}

.privacyPolicy {
  padding: 20 * @width1;
  line-height: 60 * @width1;
  font-size: 30 * @width1;
}

.privacyPolicy-top {
  font-size: 30 * @width1;
  margin-bottom: 25 * @width1;
}

.privacyPolicy-main {
  margin-bottom: 30 * @width1;
}

.li-tlt {
  font-size: 40 * @width1;
  font-weight: bold;
  line-height: 120 * @width1;
}

.li-tlt2 {
  font-size: 35 * @width1;
  font-weight: bold;
  line-height: 80 * @width1;
  margin-left: 10 * @width1;
}
.basetitle{
  font-size: 35*@width;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// privacyPolicy.vue